export const PRIVACY_PATH = "/privacy";
export const LOGIN_PATH = "/login";
export const LOGOUT_PATH = "/logout";
